import React from "react";
import { connect } from "react-redux";
import { removeMessage } from "../actions";

const mapStateToProps = ( state ) =>
{
	return {
		messages: state.messages ? state.messages : []
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		onClick: ( id ) =>
		{
			dispatch( removeMessage( id ) );
		}
	};
};

let titles = {
	"error": "Fehler!",
	"warning": "Achtung!",
	"info": "Info:"
};

let Messages = ( { onClick, messages } ) => (
	<ul className="messages noselect">
		{
			messages.map(
				( { id, message, type } ) =>
					<li onClick={() => onClick( id )} key={id} className={type}>
						<b>{titles[ type ]}</b> {message}
					</li>
			)
		}
	</ul>
);

Messages = connect(
	mapStateToProps,
	mapDispatchToProps
)( Messages );

export default Messages;
